import IdentityManager from "@arcgis/core/identity/IdentityManager";
export const getArcGISToken = async () => {
 const credential = await IdentityManager.getCredential(
   "https://aus.gis.arcadis.com/portal/sharing"
 );
 return credential.token;
};